import Default from "./fields/Default"
import Cpf from "./fields/Cpf"
import Cnpj from "./fields/Cnpj"
import Name from "./fields/Name"
import Email from "./fields/Email"
import Cellphone from "./fields/Cellphone"
import Birthdate from "./fields/Birthdate"
import Currency from "./fields/Currency"
import Text from "./fields/Text"
import Cep from "./fields/Cep"
import Quantity from "./fields/Quantity"
import Token from "./fields/Token"

export default {
  Default,
  Cpf,
  Cnpj,
  Name,
  Email,
  Cellphone,
  Birthdate,
  Currency,
  Text,
  Cep,
  Quantity,
  Token,
}
